'use client'

import Link from 'next/link'
import { ArrowRight, CheckCircle2, ShieldCheck, Clock } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { siteConfig } from '@/config/site'
import { MagneticButton } from '@/components/ui/magnetic-button'
import { Badge } from '@/components/ui/badge'

const highlights = [
  {
    icon: Clock,
    title: 'Configura en 5 minutos',
    description: 'Flujo guiado, sin código. Lo dejas operando hoy.',
  },
  {
    icon: CheckCircle2,
    title: '14 días gratis',
    description: 'Se requiere tarjeta. No se cobra hoy y puedes cancelar cuando quieras.',
  },
  {
    icon: ShieldCheck,
    title: 'Seguro por diseño',
    description: 'Controles, trazabilidad y buenas prácticas de cumplimiento.',
  },
]

export function CTABanner() {
  return (
    <section
      aria-labelledby="cta-launch-2025"
      className="border-border bg-background border-t py-20 sm:py-28"
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mx-auto grid max-w-6xl items-start gap-10 lg:grid-cols-2 lg:gap-14">
          <div className="motion-safe:animate-slide-up">
            <div className="mb-6 flex flex-wrap items-center gap-2">
              <Badge
                variant="outline"
                className="border-border bg-background text-muted-foreground rounded-full px-3 py-1 font-mono text-[11px] uppercase tracking-[0.18em]"
              >
                🚀 LANZAMIENTO 2025
              </Badge>
              <Badge
                variant="secondary"
                className="bg-muted text-muted-foreground rounded-full px-3 py-1 font-mono text-[11px] uppercase tracking-[0.18em]"
              >
                14 días gratis
              </Badge>
            </div>

            <h2
              id="cta-launch-2025"
              className="font-heading text-balance text-4xl font-semibold tracking-tight sm:text-5xl"
            >
              Empieza hoy. <span className="text-muted-foreground">Escala mañana.</span>
            </h2>

            <p className="text-muted-foreground mt-5 max-w-xl text-pretty text-base leading-relaxed sm:text-lg">
              Configura tu asistente de WhatsApp en 5 minutos. Prueba 14 días gratis con tarjeta. No
              se cobra hoy.
            </p>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
              <MagneticButton size="lg" className="h-12 rounded-full px-6 text-base" asChild>
                <Link
                  href={siteConfig.primaryCta.href}
                  prefetch={false}
                  className="flex items-center gap-2"
                >
                  {siteConfig.primaryCta.label}
                  <ArrowRight className="h-4 w-4" aria-hidden="true" />
                </Link>
              </MagneticButton>

              <Button
                size="lg"
                variant="outline"
                className="h-12 rounded-full px-6 text-base"
                asChild
              >
                <Link href="/demo">Agendar demo</Link>
              </Button>
            </div>

            <p className="text-muted-foreground mt-6 text-sm">
              Sin compromiso. Cancela cuando quieras.
            </p>
          </div>

          <div
            className="border-border bg-card motion-safe:animate-slide-up rounded-2xl border p-6 shadow-sm sm:p-8"
            style={{ animationDelay: '120ms' }}
          >
            <div className="space-y-4">
              {highlights.map((item) => (
                <div key={item.title} className="flex items-start gap-4">
                  <div className="border-border bg-background mt-0.5 inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full border">
                    <item.icon className="text-muted-foreground h-4 w-4" aria-hidden="true" />
                  </div>
                  <div className="min-w-0">
                    <p className="text-foreground text-sm font-semibold">{item.title}</p>
                    <p className="text-muted-foreground mt-1 text-sm leading-relaxed">
                      {item.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
